module.exports = __webpack_public_path__ + "assets/img/mecha-btn-ba87b507.png";